import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import "../css/Hill.css";

const API_URL = "https://adinathbuilder.com/admin/api/properties";
const IMAGE_BASE = "https://adinathbuilder.com/admin/public/";

const Hill = () => {
  const [properties, setProperties] = useState([]);
  const [hoveredLink, setHoveredLink] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const res = await fetch(API_URL);
        const data = await res.json();
        if (data.status) {
          setProperties(data.data);
        }
      } catch (error) {
        console.error("Failed to fetch properties:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  return (
    <div className="hill-container">
      <div className="hill-heading"><br />
        <p>
          OUT OF <span style={{ color: 'red' }}>STATE PROPERTY PURCHASE</span>
        </p>
      </div>

      <div className="hill-cards-container py-3 px-4">
        {loading ? (
          <p>Loading...</p>
        ) : properties.length > 0 ? (
          properties.map((property) => (
            <div
              key={property.id}
              className="hill-card"
              onMouseEnter={() => setHoveredLink(property.name)}
              onMouseLeave={() => setHoveredLink(null)}
            >
              <Link
                to={property.title === "Book" ? "/running-projects" : "/"}
                className={`hill-link ${hoveredLink === property.name ? 'active' : ''}`}
              >
                <img
                  src={`${IMAGE_BASE}${property.image}`}
                  className="hill-card-img"
                  alt={property.name}
                />
                <div className="hill-card-content">
                  <h3>{property.name}</h3>
                  <button className="tour-count">
                    {property.title === "Book" ? "Book Now" : "Coming Soon"}
                  </button>
                </div>
              </Link>
            </div>
          ))
        ) : (
          <p>No properties found.</p>
        )}
      </div>
    </div>
  );
};

export default Hill;
